export default __webpack_public_path__ + "static/media/review-img-1.133bc7a9.png";